export default "__VITE_ASSET__7f23a8c1__"